export const FALLBACK_IMAGE =
  "https://dummyimage.com/300x450/cccccc/ffffff&text=No+Image";
